import { SET_SEARCH_ENGINE_STATUS } from '~/store/modules/searchEngine/types';
import isSearchEngine from '~/helpers/search-engine-helper';
export default {
  detectSearchEngine(_ref, userAgent) {
    var {
      commit
    } = _ref;
    commit(SET_SEARCH_ENGINE_STATUS, isSearchEngine(userAgent));
  }
};